"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const JsonPathFormGroup_1 = require("./JsonPathFormGroup");
const context_1 = require("./context");
const hooks_1 = require("./hooks");
const react_if_1 = require("react-if");
const react_loops_1 = require("react-loops");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const Field_1 = require("./List/Item/Field");
const react_2 = require("@osmosys/react");
const reusables_1 = require("../../../comps/reusables");
const AdminOnly_1 = require("../../../comps/reusables/AdminOnly");
const FeedView_1 = require("./FeedView");
const SelectSampleContentFeed_1 = require("./SelectSampleContentFeed");
const inputs_1 = require("../../../inputs");
exports.ContentMappingDetail = ({ cmsId, contentMappingId }) => {
    var _a, _b;
    const { draft, resultOfContentMapping, sampleContentItem, ui, resultOfCms, save, saveResult, } = hooks_1.useContentMappingDetail({
        cmsId,
        contentMappingId,
    });
    const { filteredContentItems, failedToParse, proxyResult, sharedJsonViewProps, toggleFailedToParse, parseError, filterIsPending, mutateProxy, } = hooks_1.useProxy({
        contentFeed: draft.state.sampleContentFeed,
        contentMapping: draft.state,
    });
    if (resultOfCms.loading || resultOfContentMapping.loading) {
        return react_1.default.createElement(reusables_1.Loading, { useContainer: true });
    }
    if (resultOfCms.error) {
        return (react_1.default.createElement(react_2.OsmosysAlert, { apolloError: resultOfCms.error, floatBottom: true, dismissable: true, errorPrefix: "Failed to load CMS" }));
    }
    if (resultOfContentMapping.error) {
        return (react_1.default.createElement(react_2.OsmosysAlert, { apolloError: resultOfContentMapping.error, floatBottom: true, dismissable: true, errorPrefix: "Failed to load content mapping" }));
    }
    const fieldsAreIterable = draft.state && draft.state.fields && Array.isArray(draft.state.fields);
    const fields = fieldsAreIterable ? draft.state.fields : [];
    return (react_1.default.createElement(context_1.ContentMappingDetailContext.Provider, { value: {
            cmsId,
            contentMappingDraft: draft,
            contentMappingOriginal: ((_b = (_a = resultOfContentMapping) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.contentMapping) ? resultOfContentMapping.data.contentMapping
                : null,
            failedToParse,
            filteredContentItems: draft && draft.state && draft.state.sampleContentFeed
                ? filteredContentItems
                : null,
            filterIsPending,
            mutateProxy,
            parseError,
            proxyResult,
            sampleContentItem,
            save,
            saveResult,
            sharedJsonViewProps,
            toggleFailedToParse,
            ui,
        } },
        react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb.Extra, { to: `/integrations/${cmsId}` }, () => {
            if (resultOfCms &&
                resultOfCms.data &&
                resultOfCms.data.integration &&
                resultOfCms.data.integration.name) {
                return react_1.default.createElement(react_1.default.Fragment, null, resultOfCms.data.integration.name);
            }
            return `CMS #${cmsId}`;
        }),
        react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb.Extra, { to: `/integrations/${cmsId}/mappings`, loading: resultOfCms.loading || resultOfContentMapping.loading }, () => {
            return 'Mappings';
        }),
        react_1.default.createElement(react_2.OsmosysFlexFrame, { osysName: "ContentMappingDetail.OsmosysFlexFrame" },
            react_1.default.createElement(react_2.OsmosysFlexFrame.Row, { osysName: "ContentMappingDetail.Row" },
                react_1.default.createElement(react_2.OsmosysFlexFrame.Col, { maxWidth: 400, padding: true, osysName: "ContentMappingDetail.Col" },
                    react_1.default.createElement(react_2.OsmosysDiv, null,
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                                react_1.default.createElement(reactstrap_1.FormGroup, null,
                                    react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Content conversions (admin only)"),
                                    react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { multiple: true, resource: "contentConversion", value: draft.state.conversions, onChange: conversions => {
                                            draft.setState({
                                                conversions: conversions,
                                            });
                                        } }))),
                            react_1.default.createElement(JsonPathFormGroup_1.JsonPathFormGroup, { label: react_1.default.createElement(react_1.default.Fragment, null, "Path to array of content items"), value: draft.state.pathToArray, name: "pathToArray", mode: "list", onChange: pathToArray => {
                                    draft.setState({
                                        pathToArray,
                                    });
                                } }),
                            react_1.default.createElement(reactstrap_1.FormText, { color: "muted" },
                                "RSS feeds typically use:",
                                ' ',
                                react_1.default.createElement("pre", null, "$.data.rss.channel[0].item[*]")),
                            react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Fields"),
                            react_1.default.createElement(Field_1.ContentMappingFieldDetail, { field: {
                                    dateFormat: '',
                                    id: 'title',
                                    path: draft.state.pathToTitle,
                                    type: 'text',
                                }, draft: draft, disabled: ['id', 'type'], availableTypes: ['text', 'html'], onChange: fieldData => {
                                    draft.setState({
                                        pathToTitle: fieldData.path,
                                    });
                                } }),
                            react_1.default.createElement(Field_1.ContentMappingFieldDetail, { field: {
                                    dateFormat: '',
                                    id: 'date',
                                    path: draft.state.pathToDate,
                                    type: 'datetime',
                                }, draft: draft, disabled: ['id', 'type', 'dateFormat'], availableTypes: ['datetime'], onChange: fieldData => {
                                    draft.setState({
                                        pathToDate: fieldData.path,
                                    });
                                } }),
                            react_1.default.createElement(react_loops_1.For, { of: fields }, (field, { index }) => {
                                return (react_1.default.createElement(Field_1.ContentMappingFieldDetail, { field: field, draft: draft, onRemove: () => {
                                        const newFields = [...fields];
                                        newFields.splice(index, 1);
                                        draft.setState({
                                            fields: newFields,
                                        });
                                    }, onChange: fieldData => {
                                        const newFields = [...fields];
                                        newFields[index] = Object.assign(Object.assign({}, newFields[index]), fieldData);
                                        draft.setState({
                                            fields: newFields,
                                        });
                                    } }));
                            }),
                            react_1.default.createElement("div", { className: "my-2" },
                                react_1.default.createElement(reactstrap_1.Button, { color: "link", onClick: () => {
                                        const newFields = [...fields];
                                        newFields.push({
                                            dateFormat: '',
                                            id: '',
                                            path: '',
                                            type: 'html',
                                        });
                                        draft.setState({
                                            fields: newFields,
                                        });
                                    }, className: "p-0" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faPlus }),
                                    " Add content field"))))),
                react_1.default.createElement(react_2.OsmosysFlexFrame.Col, { osysName: "ContentMappingDetail.Col" },
                    react_1.default.createElement("div", { className: "py-2 pr-2 flex-full-col" },
                        react_1.default.createElement(react_if_1.If, { condition: !!draft.state.sampleContentFeed },
                            react_1.default.createElement(react_if_1.Then, null, () => {
                                return react_1.default.createElement(FeedView_1.ContentMappingContentFeedView, null);
                            }),
                            react_1.default.createElement(react_if_1.Else, null, () => {
                                return react_1.default.createElement(SelectSampleContentFeed_1.SelectSampleContentFeed, null);
                            }))))))));
};
exports.default = exports.ContentMappingDetail;
//# sourceMappingURL=index.js.map